var Hash = require('./_Hash'),
    Map = require('./_Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': Map ? new Map : [],
    'string': new Hash
  };
}

module.exports = mapClear;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_mapClear.js
 ** module id = 185
 ** module chunks = 0
 **/